import React from 'react'
import { useDispatch } from 'react-redux'
import { removeToast } from '@mobi/component-library/Feedback/Toast/helpers/events'
import { MULTI_BUILDER_TOAST_ID } from '@mobi/betslip/Components/MultiBuilderToastContent/MultiBuilderToastContent'
import { selectBetSlipItemCount } from '@mobi/betslip/Store/Bets/selectors'
import { useAppSelector } from '@core/Store/hooks'
import { setBetSlipIsOpen, toggleIsDropDownOpen } from '@core/Areas/AppHeader/Store'
import { trackBetSlipButtonClick } from '../../analytics'
import { Button } from '../Common/Button'

export const BetSlipButton: React.FC = () => {
  const dispatch = useDispatch()

  const betSlipCount = useAppSelector(selectBetSlipItemCount)

  const handleClick = React.useCallback(() => {
    dispatch(setBetSlipIsOpen(true))
    removeToast({ id: MULTI_BUILDER_TOAST_ID })

    dispatch(toggleIsDropDownOpen(false))
    trackBetSlipButtonClick()
  }, [dispatch])

  return <Button type='betslip' onClick={handleClick} count={betSlipCount} />
}
